import NeedHelpBanner from "@core-components/help-banner/NeedHelpBanner";
import LolRegionSelectorBanner from "@core-components/regionSelector/banner/LolRegionSelectorBanner";
import ReviewCarousel from "@core-components/reviews/ReviewCarousel";
import reviews from "@core-components/reviews/defaultReviews";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Stack } from "@mantine/core";
import LoLFAQ from "@modules/lol/faq/LoLFAQ";
import SEO from "@modules/seo/SEO";
import { SmurfsNormalFeatures } from "../components/SmurfsNormalFeatures";
import { SmurfsNormalHero } from "../components/SmurfsNormalHero";
import { SmurfsNormalInfo } from "../components/SmurfsNormalInfo";
import { SmurfsNormalProductList } from "../components/SmurfsNormalProductList";
import { useSmurfsNormal } from "../hooks/useSmurfsNormal";

const SmurfsNormalPage: React.FC = () => {
  const { t } = useAppTranslation("pages.normal");
  const { t: commonT } = useAppTranslation("common.regions");
  const { products, handleRegionChange } = useSmurfsNormal();
  const { currentRegion } = useAppRegion();

  return (
    <>
      <div>
        <SEO
          description={t("seo.description", {
            regionName: commonT(currentRegion),
            regionCode: currentRegion.toUpperCase(),
          })}
          title={t("seo.title", { region: currentRegion.toUpperCase() })}
        />
        <SmurfsNormalHero />
        <Stack
          align="center"
          className="w-full space-y-16 bg-primary-background"
        >
          <div className="-mb-16 w-full">
            <LolRegionSelectorBanner onRegionChange={handleRegionChange} />
          </div>
          <SmurfsNormalProductList products={products} />
          <NeedHelpBanner />
          <SmurfsNormalFeatures />
          <ReviewCarousel reviews={reviews} />
          <LoLFAQ />
          <SmurfsNormalInfo />
        </Stack>
      </div>
    </>
  );
};

export default SmurfsNormalPage;
